module.exports = __webpack_public_path__ + "static/media/interreg-mobimart-2021.a13f1ba5.png";